module.exports = __webpack_public_path__ + "img/30.fa60e78f.png";